import type { UpdateClientRequest, UpdateClientResponse } from "@repo/shared/types";
import { patch } from "./_client";

export function updateClient(clientId: string, payload: UpdateClientRequest) {
  return patch<UpdateClientResponse>(
    `/internal/clients/${clientId}`,
    payload satisfies UpdateClientRequest,
  );
}
